<template>
  <OwnStack row>
    <SearchInput v-model="searchQuery" />
  </OwnStack>
</template>

<script>
import { SearchInput } from '@/components/inputs'
import { OwnStack } from '@/ui'

import { mapModel } from '@/utils/computed'

export default {
  name: 'TableHeader',
  components: {
    OwnStack,
    SearchInput,
  },
  computed: {
    ...mapModel('searchQuery'),
  },
}
</script>
